// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 9631); hand-edits allowed (see docs/architecture.md)

/** `this.ROUL_VER` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_ROUL_VER(): any {
  return {
    "gold_500": new Array<any>(65, 25, 10, 0, 0, 0, 0, 0),
    "gold_3000": new Array<any>(60, 10, 20, 10, 0, 0, 0, 0),
    "gold_10000": new Array<any>(60, 5, 12, 18, 5, 0, 0, 0),
    "diam_5": new Array<any>(0, 0, 45, 35, 15, 5, 0, 0),
    "diam_25": new Array<any>(0, 0, 25, 40, 25, 10, 0, 0),
    "diam_50": new Array<any>(0, 0, 0, 5, 45, 45, 5, 0),
    "surprise_1": new Array<any>(0, 80, 20, 0, 0, 0, 0, 0),
    "surprise_2": new Array<any>(0, 40, 50, 10, 0, 0, 0, 0),
    "surprise_3": new Array<any>(0, 20, 39, 40, 1, 0, 0, 0),
    "crates_1": new Array<any>(0, 80, 18, 2, 0, 0, 0, 0),
    "crates_2": new Array<any>(0, 60, 35, 4, 1, 0, 0, 0),
    "crates_3": new Array<any>(0, 50, 40, 6, 3, 1, 0, 0),
    "crates_4": new Array<any>(0, 0, 80, 10, 6, 3, 1, 0),
    "crates_5": new Array<any>(0, 0, 60, 20, 10, 5, 3, 2),
    "crates_6": new Array<any>(0, 0, 20, 40, 20, 10, 5, 5)
  };
}
